"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.TextInputWithButton = void 0;
const react_1 = __importStar(require("react"));
const react_native_1 = require("react-native");
const base_ui_theme_themes_1 = require("@unboared/base-ui.theme.themes");
const base_ui_buttons_button_1 = require("@unboared/base-ui.buttons.button");
const base_ui_responsive_sizes_1 = require("@unboared/base-ui.responsive.sizes");
const base_ui_theme_spacing_1 = require("@unboared/base-ui.theme.spacing");
const base_ui_theme_colors_1 = require("@unboared/base-ui.theme.colors");
const TextInputWithButton = (_a) => {
    var { text, style, onChangeText, placeholder, minLength, maxLength, secureTextEntry, submitText, submitTx, onSubmit, size = 20 } = _a, props = __rest(_a, ["text", "style", "onChangeText", "placeholder", "minLength", "maxLength", "secureTextEntry", "submitText", "submitTx", "onSubmit", "size"]);
    const theme = (0, base_ui_theme_themes_1.useTheme)();
    const { normalize } = (0, base_ui_responsive_sizes_1.useNormalize)();
    const otherProps = Object.assign({ onChangeText, placeholder, minLength, maxLength, secureTextEntry }, props);
    const focusColor = theme.currentPalette.c100;
    const blurColor = theme.currentPalette.c700;
    const [focus, setFocus] = (0, react_1.useState)(false);
    const customStyle = {
        // height: normalize(20),
        minWidth: normalize(100),
        paddingVertical: normalize(base_ui_theme_spacing_1.space.tiny),
        paddingHorizontal: normalize(base_ui_theme_spacing_1.space.small),
        borderTopLeftRadius: normalize(base_ui_theme_spacing_1.size.borderRadius.smaller),
        borderBottomLeftRadius: normalize(base_ui_theme_spacing_1.size.borderRadius.smaller),
        color: base_ui_theme_colors_1.color.dark,
        borderColor: (focus ? focusColor : blurColor),
        outline: (focus ? `${focusColor} solid ${normalize(base_ui_theme_spacing_1.size.borderRadius.none)}` : 'none'),
        fontFamily: theme.textFont,
        fontSize: normalize(0.5 * size),
        overflow: 'hidden',
        textOverflow: 'ellipsis',
        backgroundColor: base_ui_theme_colors_1.color.light,
    };
    const concatStyle = Object.assign({}, customStyle, style);
    const moreProps = (react_native_1.Platform.OS === 'android') && { cursorColor: theme.buttonTextColor };
    return (react_1.default.createElement(react_native_1.View, { style: {
            flexDirection: 'row'
        } },
        react_1.default.createElement(react_native_1.TextInput, Object.assign({ style: concatStyle, value: text, onFocus: () => setFocus(true), onBlur: () => setFocus(false), placeholderTextColor: `${base_ui_theme_colors_1.color.dark}80`, onSubmitEditing: onSubmit }, otherProps, moreProps)),
        react_1.default.createElement(base_ui_buttons_button_1.Button, { style: {
                borderTopLeftRadius: 0,
                borderBottomLeftRadius: 0,
            }, tx: submitTx, text: submitText, onPress: onSubmit, size: size, textPreset: 'medium' })));
};
exports.TextInputWithButton = TextInputWithButton;
//# sourceMappingURL=text_input_with_button.js.map